// Request body field carrying the Cloudflare Turnstile token. Spread into the
// body so nothing is sent while the widget is off (no site key configured).
export const turnstileField = (token?: string | null) =>
  token ? { turnstileToken: token } : {};
